import React from 'react';

const line1 = 'DLA'.split('');
const line2 = 'STRUCTURE'.split('');

function HeroAnimation() {
  return (
    <div className="hero-animation">
      <div className="hero-animation-word">
        <div className="hero-line">
          {line1.map((letter, i) => (
            <span key={i} className="hero-animation-letter" style={{ animationDelay: (i * 0.15) + 's' }}>
              {letter}
            </span>
          ))}
        </div>
        <div className="hero-line">
          {line2.map((letter, i) => (
            <span key={i} className="hero-animation-letter" style={{ animationDelay: ((i + line1.length) * 0.15) + 's' }}>
              {letter}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HeroAnimation;
